module.exports = __webpack_public_path__ + "img/取消订单.ed41a7b0.png";